import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { baseUrl, mainBaseUrl } from "../../App";
import TemplateComponent from "./templateComponent";
import "./Templatepage.scss";

const TemplatePage = () => {
  const [templateData, settemplateData] = useState([]);
  const history = useHistory();

  const sendRoute = () => {
    history.push("/addTemplate");
  };

  function getTemplateData() {
    var config = {
      method: "get",
      url: `${mainBaseUrl}/certificate/template`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        if (response.data.length == 0) {
          settemplateData([{ data: "none" }]);
          console.log(response.data);
        } else {
          settemplateData(response.data);
          console.log(response.data);
        }
      })
      .catch(function (error) {
        alert("There's some problem while getting the template data");
      });
  }

  useEffect(() => {
    getTemplateData();
  }, []);

  return (
    <div className="templatePage">
      <div className="header">
        <h1>Certificate Templates</h1>
        <div className="button" onClick={sendRoute}>
          {/* <div className="button"> */}
          <p>Add Template</p>
        </div>
      </div>
      <div className="mainSection">
        {templateData.length === 0 ? (
          <div className="centerDiv" style={{ margin: "auto" }}>
            <h3>Loading...</h3>
          </div>
        ) : templateData[0]["data"] === "none" ? (
          <div className="centerDiv" style={{ margin: "auto" }}>
            <h3>There's no template added yet!!!</h3>
          </div>
        ) : (
          templateData.map((data) => {
            return <TemplateComponent data={data} />;
          })
        )}
      </div>
    </div>
  );
};

export default TemplatePage;
